var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolicyDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26C22.1716 26 21.5 26.6716 21.5 27.5C21.5 28.3284 22.1716 29 23 29H31C31.8284 29 32.5 28.3284 32.5 27.5C32.5 26.6716 31.8284 26 31 26H23Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32C22.1716 32 21.5 32.6716 21.5 33.5C21.5 34.3284 22.1716 35 23 35H41C41.8284 35 42.5 34.3284 42.5 33.5C42.5 32.6716 41.8284 32 41 32H23Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 39.5C21.5 38.6716 22.1716 38 23 38H41C41.8284 38 42.5 38.6716 42.5 39.5C42.5 40.3284 41.8284 41 41 41H23C22.1716 41 21.5 40.3284 21.5 39.5Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44C22.1716 44 21.5 44.6716 21.5 45.5C21.5 46.3284 22.1716 47 23 47H41C41.8284 47 42.5 46.3284 42.5 45.5C42.5 44.6716 41.8284 44 41 44H23Z",
    fill: "#071A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 22.3735C50 21.1864 49.4727 20.0606 48.5607 19.3006L39.1125 11.4271C38.3937 10.8281 37.4875 10.5 36.5518 10.5H20C16.6863 10.5 14 13.1863 14 16.5V48.5C14 51.8137 16.6863 54.5 20 54.5H44C47.3137 54.5 50 51.8137 50 48.5V22.3735ZM44 51.5H20C18.3431 51.5 17 50.1569 17 48.5V16.5C17 14.8431 18.3431 13.5 20 13.5H35.5V21.5C35.5 23.433 37.067 25 39 25H47V48.5C47 50.1569 45.6569 51.5 44 51.5ZM38.5 21.5V14.8218L46.6402 21.6053C46.7687 21.7123 46.8666 21.8485 46.9276 22H39C38.7239 22 38.5 21.7761 38.5 21.5Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolicyDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/policy-documents.556c42a8724b9579f5447216446111cd.svg";